var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('model-data-table',_vm._b({attrs:{"no-actions":!_vm.$can('VIEW_DETAIL_PURCHASE_PROVIDER'),"no-remove":"","remind-key":"provider-list"},on:{"detail":_vm.submitUpdate}},'model-data-table',_vm.tableProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }